import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Mfk, ValidatedMfk} from '@uiowa/uiowa-mfk';

@Injectable({
    providedIn: 'root'
})
export class MfkService {
    private readonly apiUrl = 'api/mfk';

    constructor(
        private readonly httpClient: HttpClient
    ) { }

    validateMfk(mfk: Mfk): Observable<ValidatedMfk> {
        return this.httpClient.post<ValidatedMfk>(`${this.apiUrl}/validate`, mfk);
    }
}